import {Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngbd-datepicker-popup',
  templateUrl: './datepicker-popup.html'
})
export class NgbdDatepickerPopup  implements OnInit{
  model;

@Input() fechaSeleccionada: any;
@Output() fechaCambiada = new EventEmitter();

public fecha:Date;

 ngOnInit() {
   
   console.log('fecha:' + this.fechaSeleccionada);

   if (this.fechaSeleccionada != undefined)
   {
     
      let mes:number = this.fechaSeleccionada.getMonth();
  
      this.model = {
                      year: this.fechaSeleccionada.getFullYear(), 
                      month: mes + 1, 
                      day: this.fechaSeleccionada.getDate() 
                  }
   }
 
 }

 onFechaCambiada(){

   try {  
      if ( isDate(new Date(this.model.year, this.model.month -1, this.model.day ) ) ){

          this.fecha = new Date(this.model.year, this.model.month -1, this.model.day);

          console.log(this.fecha);
          
          this.fechaCambiada.emit(this.fecha);
          
      }
   } catch (error) {
     console.log(error)
   }     
 } 

  
}

export default function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/bootstrap/datepicker-popup.ts